










































import { Component, Mixins, Prop } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";
import { Benefits } from "@/interfaces/general";
import BenefitCard from "@/components/home/BenefitCard.vue";

@Component({
  components: { BenefitCard },
  computed: {},
  methods: {}
})
export default class HomeBenefits extends Mixins(GlobalMixin) {
  @Prop({ type: Array, required: true }) benefits!: Benefits[];
  @Prop({ type: String, default: "" }) title?: string;
  @Prop({ type: Boolean, default: false }) anticipated?: boolean;
}
